import { connect } from 'react-redux'

import DeleteNDASignatureView from './view.jsx';
import { deleteNDATemplate } from 'src/legacy/redux/actions/ndaTemplate';


const mapStateToProps = (state, ownProps) => {
  return {
    deleting: state.legacyRootReducer.settings.ndaTemplates.deleting
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteNDATemplate: (id) => {
      return dispatch(deleteNDATemplate(id));
    }
  }
}

const DeleteNDASignatureContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteNDASignatureView)

export default DeleteNDASignatureContainer;